"use client";

import { TabPanel, TabProvider } from "@ariakit/react";
import { useEffect, useState } from "react";

import styles from "./DiscoveryResult.module.scss";
import { DiscoverTabs } from "./DiscoverTabs";
import { ArticleSearchList } from "../Feed/DiscoverLayout/ArticleSearchList";
import { TopicsSearchList } from "../Feed/DiscoverLayout/TopicsSearchList";
import { Button } from "../Button/Button";
import { searchArticlesAndTopicsFromUrl } from "../../services/searchArticlesAndTopicsFromUrl";
import { DotLoader } from "../DotLoader/DotLoader";

export function DiscoveryResult({
  searchResult,
  searchQuery,
  url,
  empty,
}: {
  searchResult: any;
  searchQuery: string;
  url: string;
  empty?: boolean;
}) {
  const [articles, setArticles] = useState(searchResult.data.articles);
  const [topics, setTopics] = useState(searchResult.data.topics);
  const [nextUrl, setNextUrl] = useState(url);
  const [loading, setLoading] = useState(false);
  const [isMoreTopics, setIsMoreTopics] = useState(true);
  const [isMoreArticles, setIsMoreArticles] = useState(true);

  useEffect(() => {
    setArticles(searchResult.data.articles);
    setTopics(searchResult.data.topics);
    if (empty) {
      setIsMoreArticles(false);
      setIsMoreTopics(false);
    }
  }, [empty, searchResult]);

  const fetchMore = async () => {
    setLoading(true);
    const result = await searchArticlesAndTopicsFromUrl(nextUrl);
    if (result.error) {
      throw result.error;
    }
    setNextUrl(result.data.nextPage);
    if (result.data.articles.length) {
      setArticles([...articles, ...result.data.articles]);
    } else {
      setIsMoreArticles(false);
    }

    if (result.data.topics.length) {
      setTopics([...topics, ...result.data.topics]);
    } else {
      setIsMoreTopics(false);
    }
    setLoading(false);
  };

  return (
    <div className={styles.containerList}>
      <TabProvider defaultSelectedId="articles">
        <div className={styles.tabs}>
          <DiscoverTabs
            label="Typ av resultat"
            tabs={[
              {
                title: "Artiklar",
                id: "articles",
              },
              {
                title: "Ämnen",
                id: "topics",
              },
            ]}
          />
        </div>
        <TabPanel tabId="articles">
          <ArticleSearchList
            articles={articles}
            searchQuery={searchQuery || ""}
          />
          {isMoreArticles && !loading && (
            <div className={styles.loadMoreButtonContainer}>
              <Button
                onClick={fetchMore}
                size="small"
                variant="primary"
                text="Ladda fler artiklar"
              />
            </div>
          )}
        </TabPanel>
        <TabPanel tabId="topics">
          <div className={styles.topicsContainer}>
            <TopicsSearchList topics={topics} searchQuery={searchQuery || ""} />
          </div>
          {isMoreTopics && !loading && (
            <div className={styles.loadMoreButtonContainer}>
              <Button
                onClick={fetchMore}
                size="small"
                variant="primary"
                text="Ladda fler ämnen"
              />
            </div>
          )}
        </TabPanel>
      </TabProvider>
      {loading && <DotLoader />}
    </div>
  );
}
